import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CircularProgress } from '@material-ui/core';
import { updateUser, getUserList, UserChangePassword, getUserPermissions } from "../../../redux/actions/admin/UserActions"
import { getRoleList } from "../../../redux/actions/admin/RoleActions";
import validator from 'validator';
import $ from 'jquery';
import { DropzoneArea } from 'material-ui-dropzone';
import CustomAlert from '../../shared/views/CustomAlert';
import localStorageService from '../../../services/localStorageService';
import Select from 'react-select';


let UserDetail = (props) => {
    const {       
        getUserPermissions,
        storeUsers = {},
        storeRoles = {},
        UserChangePassword,
        getRoleList,
        getUserList,
        updateUser,
    } = props;

    const descriptionHtmlEditor = useRef();
    const [isLoading, setIsLoading] = React.useState(true);
    const [user, setUser] = React.useState(
        {
            id: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            phoneNumber1: "",
            roles: []
        });
    const [userToUpdate, setUserToUpdate] = React.useState(
        {
            id: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            phoneNumber1: "",
            roles: []
        }
    )
    const [userId, setUserId] = React.useState("");
    const [currentUserId, setCurrentUserId] = React.useState("");
    const [preview, setPreview] = React.useState();
    // const [isUpdatting, setIsUpdating] = React.useState(false);
    const [roleList, setRoleList] = React.useState(null);
    const closeUserChangePasswordtModal = useRef();
    const [isUploading, setIsUploading] = React.useState(false);
    const [isDeletting, setIsDeletting] = React.useState(false);
    const [hasMissingValue, setHasMissingValue] = React.useState(true);
    const [published, setPublished] = React.useState(false);
    const [invalideEmail1, setInvalideEmail1] = React.useState(false);
    const [invalideEmail2, setInvalideEmail2] = React.useState(false);
    const [userTopermit, setUserTopermit] = React.useState(false);
    const [userToChangePassword, setUserToChangePassword] = React.useState(false);
    const [passwordPending, setPasswordPending] = React.useState(false);
    const [isPermiting, setIsPermiting] = React.useState(false);
    const [userPermissionsList, setUserPermissionsList] = React.useState([]);
    const [userRoleSelectListOptions, setUserRoleSelectListOptions] = React.useState([]);
    const [userChangePassword, setUserChangePassword] = React.useState({ id: "", newPassword: "" });
    const [selectedUser, setSelectedUser] = React.useState(null);
    const [selectedRole, setSelectedRole] = React.useState([]);
    const [isCreatting, setIsCreatting] = React.useState(false);
    const [isUpdatting, setIsUpdatting] = React.useState(false);
    const [userList, setUserList] = React.useState(null);
    const [invalideEmail, setInvalideEmail] = React.useState(false);
    const [loginData, setLoginData] = React.useState(
        {
            id: "",
            newPassword: "",
        });


    useEffect(() => {
        let match = props.match;
        if (match != undefined) {
            let params = match.params;
            if (params !== undefined && params.userId != undefined && userId == "") {
                setUserId(params.userId);
            }
        };
        let user = localStorageService.getItem("malibaara_auth_user");
        if (user) {
            setCurrentUserId(user.id);
        }
    }, []);

    useEffect(() => {
        if (currentUserId != "") {
            getUserPermissions(currentUserId).then(resp => {
                setUserPermissionsList(resp.permissions);

            });
            console.log("permission");
        }
    }, [currentUserId])


    useEffect(() => {
        if (userId != "") {
            if (storeUsers.userList.length > 0) {
                let user = storeUsers.userList.find(u => u.id == userId);
                if (user != null) {
                    setUserToUpdate(user);
                    setIsLoading(false);
                }
            }
            else if (storeUsers.userList.length == 0) {
                getUserList().then(response => {
                    if (response) {
                        let user = response.find(u => u.id == userId);
                        if (user != null) {
                            setUserToUpdate(user);
                            setIsLoading(false);
                        }
                    }
                })
            }

            if (storeRoles.roleList.length > 0) {
                setRoleList(storeRoles.roleList);
            }
            else if (storeRoles.roleList.length == 0) {
                getRoleList().then(response => {
                    if (response && response.rolesList) {
                        setRoleList(response.rolesList);
                    }
                })
            }
        }
    }, [userId])

    useEffect(() => {
        if (roleList && roleList.length) {
            let result = []
            roleList.forEach(role => {
                result.push({ label: role.name, id: role.id, value: role.id });
            })
            setUserRoleSelectListOptions(result);
        }
    }, [roleList])


    const handleUpdateSubmit = () => {
        setIsUpdatting(true);
        setPublished(false);
        let userCopy = userToUpdate;
        let result = [];
        let roles = [...new Set(userToUpdate.roles?.map(item => item.id ? item.id : item))];
        roles?.forEach(item => {
            result.push({ id: item });
        })
        userCopy.roles = result;
        updateUser(userCopy).then(response => {

            if (response.success) {
                setUserList(response.usersList);
                setIsUpdatting(false);
                setPublished(true);
            }
            setIsUpdatting(false);
        });
    }

    // Start keydown mechanism
    let onKeydown = event => {
        if (event.code === "Enter" || event.code === "NumpadEnter") {
            if (!hasMissingValue) {
                handleUpdateSubmit();
            }
            event.preventDefault();
        }
    };


    useEffect(() => {
        document.addEventListener("keydown", onKeydown);
        return () => {
            document.removeEventListener("keydown", onKeydown);
        };
    }, [onKeydown]);
    //End keydown mechanism


    useEffect(() => {
        if (userToUpdate.firstName == ""
            || userToUpdate.firstName == undefined
            || userToUpdate.lastName == ""
            || userToUpdate.lastName == undefined
            || userToUpdate.email == ""
            || userToUpdate.email == undefined
            || !userToUpdate.roles?.length
            || userToUpdate.roles == undefined
        ) {
            setHasMissingValue(true);
        }
        else if (userToUpdate.firstName?.length > 50
            || userToUpdate.lastName?.length > 50
            || userToUpdate.email?.length > 50
            || (userToUpdate.email != "" && !validator.isEmail(userToUpdate.email))
            || userToUpdate.phoneNumber1?.length > 50
            || (userToUpdate.phoneNumber1 != undefined && userToUpdate.phoneNumber1 != "" && !(new RegExp(/^[0-9\b]+$/)).test(userToUpdate.phoneNumber1))
        ) {
            setHasMissingValue(true);
        }
        else {
            setHasMissingValue(false);
        }
    }, [userToUpdate])

    let handleUpdateUser = (event) => {
        setIsUpdatting(true);
        let userCopy = userToUpdate;
        let result = [];
        let roles = [...new Set(userToUpdate.roles?.map(item => item.id ? item.id : item))];
        roles?.forEach(item => {
            result.push({ id: item });
        })
        userCopy.roles = result;
        updateUser(userCopy).then(response => {

            if (response.success) {
                setUserList(response.usersList);
                setIsUpdatting(false);
            }
        });
    }

    let handleChangeUserPasswordSubmit = () => {
        setIsPermiting(true);
        setPublished(false);
        let data = { id: currentUserId, newPassword: loginData.newPassword };
        UserChangePassword(data).then(resp => {
            if (resp) {
                setIsPermiting(false);
                setPublished(true);
                setTimeout(() => {
                    setPublished(false);
                    closeUserChangePasswordtModal.current.click();
                }, 1500);
            }
        })
    }

    let openUserChangePasswordModal = (user) => {
        setSelectedUser(user);
        setUserToChangePassword(true);
    }

    return (
        <>
            <React.Fragment>
                {isLoading ? (
                    <div className="row bg-white pt-4 mt-lg-0">
                        <div className="col-lg-12">
                            <div className="loading-container bg-white">
                                <CircularProgress />
                                <div>Chargement de l'utilisateur en cours...</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-lg-12 mt-4 bg-white pt-0 mt-lg-0">
                                <div className="bg-light-2 p-4">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="section-title" style={{ marginLeft: "-10px" }}>
                                            <h4 className="title" style={{ paddingBottom: "15px" }}>
                                                <span>Informations de l'utilisateur - {userToUpdate.firstName}</span>
                                            </h4>
                                        </div>
                                    </div>
                                    <div
                                        className="col-lg-6"
                                        style={{ textAlign: "right", marginTop: "30px" }}
                                    >
                                        {userPermissionsList?.some(p => p.name === "AllowAdminToChangeUserPassword") && (
                                                <a href="assets/#" className="text-primary" data-toggle="modal" title="Modifier le mot de passe" data-target="#changeUserPasswordModal" data-original-title="Permit">
                                                    <i className="fa fa-key fa-1-5x" onClick={(e) => openUserChangePasswordModal(user)}></i>
                                                </a>
                                            )}
                                    </div>
                                    </div>
                                    <div style={{ marginLeft: "-12px" }}>
                                        <div className="form-row">
                                            <div className="form-group col-md-12">
                                                <label>Prénom *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="firstName"
                                                    value={userToUpdate.firstName}
                                                    onChange={(e) => {
                                                        let val = e.target?.value;
                                                        setUserToUpdate(prevState => { return { ...prevState, firstName: val } });
                                                    }}
                                                />
                                                {userToUpdate.firstName?.length > 200 && (
                                                    <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                )}
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Nom *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="companyName"
                                                    value={userToUpdate.lastName}
                                                    onChange={(e) => {
                                                        let val = e.target?.value;
                                                        setUserToUpdate(prevState => { return { ...prevState, lastName: val } });
                                                    }}
                                                />
                                                {userToUpdate.lastName?.length > 200 && (
                                                    <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                )}
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Adresse email *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="email"
                                                    value={userToUpdate.email}
                                                    onChange={(e) => {
                                                        let val = e.target?.value;
                                                        let isValide = validator.isEmail(e.target.value);
                                                        setUserToUpdate(prevState => { return { ...prevState, email: val } });
                                                        if (invalideEmail) {
                                                            setInvalideEmail(!isValide);
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        let val = validator.isEmail(e.target.value);
                                                        setInvalideEmail(!val);
                                                    }}
                                                />
                                                {userToUpdate.email?.length > 50 && (
                                                    <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                )}
                                                {(userToUpdate.email != "" && invalideEmail) && (
                                                    <p style={{ color: "red" }}>Format d'email invalide</p>
                                                )}
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Numéro de téléphone *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="companyPhoneNumber1Contact"
                                                    value={userToUpdate.phoneNumber1}
                                                    onChange={(e) => {
                                                        let val = e.target?.value;
                                                        setUserToUpdate(prevState => { return { ...prevState, phoneNumber1: val } });
                                                    }}
                                                />
                                                {userToUpdate.phoneNumber1?.length > 50 && (
                                                    <p style={{ color: "red" }}>le nombre maximum de caractères a été dépassé</p>
                                                )}
                                                {(userToUpdate.phoneNumber1 != "" && !(new RegExp(/^[0-9\b]+$/)).test(userToUpdate.phoneNumber1)) && (
                                                    <p style={{ color: "red" }}>Format invalide</p>
                                                )}
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Rôle *</label>
                                                <Select
                                                    type="text"
                                                    name="companyPhoneNumber2Contact"
                                                    value={userRoleSelectListOptions.filter(opt => [...new Set(userToUpdate.roles?.map(item => item.id ? item.id : item))]?.some(r => r == opt.value))}
                                                    options={userRoleSelectListOptions}
                                                    isMulti
                                                    onChange={(option) => {
                                                        let unique = [...new Set(option.map(item => item.value))];
                                                        setUserToUpdate(prevState => {
                                                            return { ...prevState, roles: unique }
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleUpdateSubmit}
                                                    disabled={isUpdatting || hasMissingValue}
                                                >
                                                    Sauvegarder &nbsp; {isUpdatting ? <CircularProgress size={15} /> : <span></span>}
                                                </button>
                                            </div>
                                            {published && (
                                                <div className="col-12 mt-4">
                                                    <CustomAlert content="L'utilisateur a été modifiée avec succès." />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Start Change password modal */}
                        <div className="modal fade" id="changeUserPasswordModal" tabIndex="-1" role="dialog" aria-modal="true">
                            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" role="document">

                                <div className="modal-content">
                                    <div className="modal-header p-4">
                                        <h4 className="mb-0 text-center">Modifier le mot de passe de: {selectedUser?.firstName}</h4>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>

                                    <form className="mt-2">
                                        {passwordPending == true ? (
                                            <div className="loading-container bg-white">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            <>
                                                {published == true ? (
                                                    <div className="col-12 mt-2 mb-4">
                                                        <CustomAlert content="Le mot de passe à été modifié avec succès." />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="modal-body">

                                                            <div className="form-row">
                                                                <label htmlFor="password2">Mot de passe *</label>
                                                                <input
                                                                    type="password"
                                                                    className="form-control"
                                                                    id="password31"
                                                                    value={loginData?.newPassword}
                                                                    onChange={(e) => {
                                                                        let val = e.target?.value;
                                                                        setLoginData(prevState => { return { ...prevState, newPassword: val } })
                                                                    }}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className="modal-footer">
                                                            <button
                                                                ref={closeUserChangePasswordtModal}
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                data-dismiss="modal"
                                                            >
                                                                Annuler
                                                            </button>
                                                            <button type="button" className="btn btn-primary" onClick={handleChangeUserPasswordSubmit}>
                                                                Sauvegarder &nbsp; {isPermiting ? <CircularProgress size={15} /> : <span></span>}
                                                            </button>
                                                        </div>

                                                    </>
                                                )}
                                            </>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                        {/*End change password modal*/}

                    </>
                )}
            </React.Fragment>
        </>
    )
}

UserDetail.propTypes = {
    getRoleList: PropTypes.func.isRequired,
    getUserList: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
    storeUsers: PropTypes.object.isRequired,
    UserChangePassword: PropTypes.func.isRequired,
    getUserPermissions: PropTypes.func.isRequired,
    // storeRoles: PropTypes.object.isRequired,

}

const mapStateToProps = state => ({
    getRoleList: PropTypes.func.isRequired,
    getUserList: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
    storeUsers: state.users,
    storeRoles: state.role,
    UserChangePassword: PropTypes.func.isRequired,
    getUserPermissions: PropTypes.func.isRequired,
})

export default connect(mapStateToProps, {
    getRoleList,
    getUserList,
    updateUser,
    UserChangePassword,
    getUserPermissions,
})(UserDetail)